<template>
    <img
        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABHElEQVR4nO2ZX2oCMRjE9y7mO0+x+FB7HrUgCD3Ifl5Bt55Ab2HfygpCPpfIBv9AVEpSmhh2fjAv+zSTmcBCigIAAJ4axTJQLF+K9Y5YTAwp1jvFUtFcXv9knlg+Y5mmh2FkFnzyqc3TVX3/AKWsnsC4sSplGdBAvM3TrzPStXeA1KbJEQJQ1xqYrBvzvTdW43WTV4D36mBchtUhnwAfm+YmQPstmwDDOw28LTNqgFjs7rd7YzXK7Q7QP6hAAO5YAy4I4AsacMCEfMGEHDAhXzAhB0zIF+r6vxAhgHS8AcW6Tm2azir1T0AAqZIb57P0wjtA+7iQ3rhY9eby4h3g1MIstXnFMg0yf2mCpd9WGPuJiVgvgk8eAACKWBwBftdJd/STXEMAAAAASUVORK5CYII="
        alt=""
    />
</template>
